// extracted by mini-css-extract-plugin
module.exports = {"icon":"_2v84Vcw"};
    if(module.hot) {
      // 1545369455464
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  